import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
import { MAX_CARD_WIDTH } from '../../styles/jss/utils';
// New product-card redesign has a portrait image matching imageContainerNew in ProductCard,
// which now uses a single fixed 384/500 aspect ratio across all breakpoints.
// Height = 500px image + ~280px content section, applied at every breakpoint.
export const NEW_DESIGN_SKELETON_CARD_HEIGHT = 780;
const useStyles = makeStyles()((theme) => ({
    productCard: {
        width: '100%',
        maxWidth: `${MAX_CARD_WIDTH}px`,
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        boxShadow: theme.isFlyingFlowers
            ? '0px 2px 2px rgba(60, 60, 59, 0.48), 0px 4px 8px rgba(60, 60, 59, 0.16)'
            : '0px 2px 2px rgba(0, 0, 0, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.12)',
        '& .react-multi-carousel-dot-list': {
            position: 'initial',
        },
        [theme.breakpoints.up('md')]: {
            margin: 0,
        },
        '& span > span': {
            borderRadius: 0,
            lineHeight: 'inherit',
        },
    },
    productCardNewDesign: {
        // Single fixed height (500px image + content section) across all breakpoints, mirrors imageContainerNew
        height: `${NEW_DESIGN_SKELETON_CARD_HEIGHT}px`,
        boxShadow: 'none !important',
        border: 'none !important',
    },
    productGrid: {
        flexGrow: 1,
        [theme.breakpoints.down('xl')]: {
            justifyContent: 'center',
        },
    },
    gridItem: {
        width: '100%',
    },
    list: {
        display: 'grid',
        gridTemplateColumns: 'repeat(1, 1fr)',
        [theme.breakpoints.between('sm', 'xl')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridGap: spacing.medium,
        },
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: 'repeat(4, 1fr)',
            gridGap: spacing.medium,
        },
    },
    topSection: {},
    contentSection: {
        padding: spacing.medium,
    },
    /** Reduced-padding content wrapper for the new portrait card design — mirrors contentWrapperNew in ProductCard */
    contentSectionNewDesign: {
        padding: spacing.small,
    },
    /** Price + promo + favourites row — full-width single bar */
    skeletonPriceRowNew: {
        marginBottom: spacing.xs,
        '& .react-loading-skeleton': {
            height: '36px',
            width: '100%',
        },
    },
    /** Product name row — has bottom margin to create space before the bullet list */
    skeletonTitleNew: {
        margin: `${spacing.xs} 0 ${spacing.small} 0`,
        '& .react-loading-skeleton': {
            height: '20px',
            width: '90%',
        },
    },
    /** Individual bullet-list item — zero bottom margin so bullets are tightly packed */
    skeletonBulletItemNew: {
        marginBottom: 0,
        '& .react-loading-skeleton': {
            height: '24px',
            width: '100%',
        },
    },
    cardTitle: {
        margin: `${spacing.small} 0`,
    },
    cardMetrics: {
        marginBottom: spacing.xs,
        '& .react-loading-skeleton': {
            height: '36px',
            width: '100%',
            [theme.breakpoints.up('md')]: {
                height: '50px',
            },
        },
    },
    cardPrice: {
        marginBottom: spacing.large,
        marginTop: spacing.small,
        '& .react-loading-skeleton': {
            height: '36px',
            width: '100%',
            [theme.breakpoints.up('md')]: {
                height: '52px',
            },
        },
    },
    spotlightBanner: {
        width: '100%',
        gridColumn: '1/-1',
        '& .react-loading-skeleton': {
            height: '404px',
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                height: '316px',
            },
            [theme.breakpoints.up('lg')]: {
                height: '300px',
            },
        },
    },
    skeletonProductImage: {
        height: 0,
        paddingBottom: '100%',
    },
    skeletonProductImagePortrait: {
        // Single fixed ratio mirrors imageContainerNew in ProductCard.styles.ts exactly
        width: '100%',
        aspectRatio: `${MAX_CARD_WIDTH} / 500`,
        paddingBottom: 0,
    },
    cardReviews: {
        minHeight: '33.5px',
    },
}));
export default useStyles;
